const _excluded = ["statusIds", "lastStatusId", "featuredStatusIds", "divideType", "onLoadMore", "timelineId", "isLoading", "isPartial", "children"];
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/status_list.tsx";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/esnext.iterator.to-array.js";
import classNames from 'classnames';
import debounce from 'lodash/debounce';
import React, { useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import LoadGap from 'soapbox/components/load_gap';
import ScrollableList from 'soapbox/components/scrollable_list';
import StatusContainer from 'soapbox/containers/status_container';
import FeedSuggestions from 'soapbox/features/feed-suggestions/feed-suggestions';
import PlaceholderStatus from 'soapbox/features/placeholder/components/placeholder_status';
import PendingStatus from 'soapbox/features/ui/components/pending_status';
import { useAppSelector } from 'soapbox/hooks';
const renderPendingStatus = statusId => {
  const idempotencyKey = statusId.replace(/^末pending-/, '');
  return /*#__PURE__*/React.createElement(PendingStatus, {
    key: statusId,
    idempotencyKey: idempotencyKey,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  });
};
const renderFeedSuggestions = (suggestedProfiles, areSuggestedProfilesLoaded) => {
  if (!areSuggestedProfilesLoaded && suggestedProfiles.size === 0) return null;
  return /*#__PURE__*/React.createElement(FeedSuggestions, {
    key: "suggestions",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 10
    }
  });
};
const renderLoadGap = (index, statusIds, onLoadMore, isLoading) => {
  const ids = statusIds.toList();
  const nextId = ids.get(index + 1);
  const prevId = ids.get(index - 1);
  if (index < 1 || !nextId || !prevId || !onLoadMore) return null;
  return /*#__PURE__*/React.createElement(LoadGap, {
    key: 'gap:' + nextId,
    disabled: isLoading,
    maxId: prevId,
    onClick: onLoadMore,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 5
    }
  });
};
const renderFeaturedStatuses = (featuredStatusIds, handleMoveUp, handleMoveDown, timelineId) => {
  if (!featuredStatusIds) return [];
  return featuredStatusIds.toArray().map(statusId => /*#__PURE__*/React.createElement(StatusContainer, {
    key: `f-${statusId}`,
    timeline: !!timelineId,
    id: statusId,
    featured: true,
    onMoveUp: handleMoveUp,
    onMoveDown: handleMoveDown,
    contextType: timelineId,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 5
    }
  }));
};
const renderStatuses = (isLoading, statusIds, onLoadMore, handleMoveUp, handleMoveDown, timelineId, suggestedProfiles, areSuggestedProfilesLoaded) => {
  if (isLoading || statusIds.size > 0) {
    return statusIds.toList().reduce((acc, statusId, index) => {
      let el = null;
      if (statusId === null) {
        el = renderLoadGap(index, statusIds, onLoadMore, isLoading);
      } else if (statusId.startsWith('末suggestions-')) {
        const suggestions = renderFeedSuggestions(suggestedProfiles, areSuggestedProfilesLoaded);
        if (suggestions) el = suggestions;
      } else if (statusId.startsWith('末pending-')) {
        el = renderPendingStatus(statusId);
      } else {
        el = /*#__PURE__*/React.createElement(StatusContainer, {
          timeline: !!timelineId,
          key: statusId,
          id: statusId,
          onMoveUp: handleMoveUp,
          onMoveDown: handleMoveDown,
          contextType: timelineId,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 108,
            columnNumber: 15
          }
        });
      }
      acc.push(/*#__PURE__*/React.createElement("div", {
        className: "sm:pb-3",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119,
          columnNumber: 9
        }
      }, el));
      return acc;
    }, []);
  } else {
    return [];
  }
};
const renderScrollableContent = (featuredStatusIds, isLoading, statusIds, onLoadMore, handleMoveUp, handleMoveDown, timelineId, suggestedProfiles, areSuggestedProfilesLoaded) => {
  const featuredStatuses = renderFeaturedStatuses(featuredStatusIds, handleMoveUp, handleMoveDown, timelineId);
  const statuses = renderStatuses(isLoading, statusIds, onLoadMore, handleMoveUp, handleMoveDown, timelineId, suggestedProfiles, areSuggestedProfilesLoaded);
  if (featuredStatuses && statuses) {
    return featuredStatuses.concat(statuses);
  } else {
    return statuses;
  }
};
const makePlaceholder = ({
  timelineId
}) => props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "sm:pb-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 10
    }
  }, /*#__PURE__*/React.createElement(PlaceholderStatus, _extends({}, props, {
    timeline: !!timelineId,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 35
    }
  })));
};

/** Feed of statuses, built atop ScrollableList. */
const StatusList = _ref => {
  let {
      statusIds,
      lastStatusId,
      featuredStatusIds,
      divideType = 'border',
      onLoadMore,
      timelineId,
      isLoading,
      isPartial,
      children
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  const Placeholder = useMemo(() => makePlaceholder({
    timelineId
  }), [timelineId]);
  const [root, setRoot] = useState(null);
  const suggestedProfiles = useAppSelector(state => state.suggestions.items);
  const areSuggestedProfilesLoaded = useAppSelector(state => state.suggestions.isLoading);
  const getFeaturedStatusCount = useCallback(() => {
    return featuredStatusIds?.size || 0;
  }, [featuredStatusIds?.size]);
  const getCurrentStatusIndex = useCallback((id, featured) => {
    if (featured) {
      return featuredStatusIds?.keySeq().findIndex(key => key === id) || 0;
    } else {
      return statusIds.keySeq().findIndex(key => key === id) + getFeaturedStatusCount();
    }
  }, [featuredStatusIds, getFeaturedStatusCount, statusIds]);
  const selectChild = useCallback(index => {
    root?.children[index].scrollIntoView({
      behavior: 'smooth'
    });
  }, [root]);
  const handleMoveUp = useCallback((id, featured = false) => {
    const elementIndex = getCurrentStatusIndex(id, featured) - 1;
    selectChild(elementIndex);
  }, [getCurrentStatusIndex, selectChild]);
  const handleMoveDown = useCallback((id, featured = false) => {
    const elementIndex = getCurrentStatusIndex(id, featured) + 1;
    selectChild(elementIndex);
  }, [getCurrentStatusIndex, selectChild]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const _handleLoadOlder = useCallback(() => {
    const maxId = lastStatusId || statusIds.last();
    if (onLoadMore && maxId) {
      onLoadMore(maxId.replace('末suggestions-', ''));
    }
  }, [lastStatusId, statusIds, onLoadMore]);
  const handleLoadOlder = useMemo(() => debounce(_handleLoadOlder, 300, {
    leading: true
  }), [_handleLoadOlder]);
  const scrollableContent = useMemo(() => renderScrollableContent(featuredStatusIds, isLoading, statusIds, onLoadMore, handleMoveUp, handleMoveDown, timelineId, suggestedProfiles, areSuggestedProfilesLoaded), [areSuggestedProfilesLoaded, featuredStatusIds, handleMoveDown, handleMoveUp, isLoading, onLoadMore, statusIds, suggestedProfiles, timelineId]);
  if (isPartial) {
    return /*#__PURE__*/React.createElement("div", {
      className: "regeneration-indicator",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 210,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 211,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "regeneration-indicator__label",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 212,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "regeneration_indicator.label",
      tagName: "strong",
      defaultMessage: "Loading\u2026",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 213,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "regeneration_indicator.sublabel",
      defaultMessage: "Your home feed is being prepared!",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 214,
        columnNumber: 13
      }
    }))));
  }
  return /*#__PURE__*/React.createElement(ScrollableList, _extends({
    ref: setRoot,
    id: "status-list",
    prepend: children,
    isLoading: isLoading,
    onLoadMore: handleLoadOlder,
    placeholderComponent: Placeholder,
    placeholderCount: 20,
    className: classNames('divide-y divide-solid divide-gray-200 dark:divide-slate-700', {
      'divide-none': divideType !== 'border'
    })
  }, other, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 222,
      columnNumber: 5
    }
  }), scrollableContent);
};
export default StatusList;